import { ALL } from "dns";
import { PERMISSIONS_TRACER } from "./permissions-tracer.constants";

export const PERMISSION_GROUPS_TRACER = {
    BOOKINGS: [PERMISSIONS_TRACER.BOOKINGS.VIEW],
    REP: [PERMISSIONS_TRACER.REP],
    MANAGE_TEAM: [PERMISSIONS_TRACER.MANAGE_TEAM.VIEW],
    MY_SCHOOLS: [PERMISSIONS_TRACER.MY_SCHOOLS.VIEW],
    ALL: [
        PERMISSIONS_TRACER.BOOKINGS.VIEW,
        PERMISSIONS_TRACER.REP.VIEW,
        PERMISSIONS_TRACER.MANAGE_TEAM.VIEW,
        PERMISSIONS_TRACER.MY_SCHOOLS.VIEW,
        PERMISSIONS_TRACER.LEAVE_APPROVAL
    ]
};